/**
 * Characters that may follow an @-mention, including the `@` of a mention
 * written straight after it. Mirrored by the API's template resolver.
 */
export const MENTION_DELIMITER_CLASS = '[\\s,.:;!?@]'
export const MENTION_DELIMITER = new RegExp(MENTION_DELIMITER_CLASS)
export const EMPLOYEE_TOKEN_PATTERN = /@{{employee:(.*?)}}/g

export const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const replaceRecruitersIdWithName = (content, recruiters) => {
  if (!content) return ''
  return content.replace(/{{employee:(.*?)}}/g, (match, id) => {
    const employee = recruiters.find((recruiter) => recruiter.value === id)
    return employee ? `${employee.label}` : match
  })
}

export const replaceNamesWithRecruitersId = (content, recruiters) => {
  let result = content

  const sortedRecruiters = [...recruiters].sort(
    (a, b) => b.label.length - a.label.length
  )

  for (const recruiter of sortedRecruiters) {
    const escapedLabel = escapeRegExp(recruiter.label.trim())
    const pattern = new RegExp(
      `@${escapedLabel}(?=${MENTION_DELIMITER_CLASS}|$)`,
      'g'
    )
    result = result.replace(pattern, `@{{employee:${recruiter.value}}}`)
  }

  return result
}
